import ContinueSessionHomeScreenButton from 'src/components/molecules/ContinueSessionHomeScreenButton';
import FavoritesHomeScreenButton from 'src/components/molecules/FavoritesHomeScreenButton';
import PickCoachHomeScreenButton from 'src/components/molecules/PickCoachHomeScreenButton';
import SelfObservationHomeScreenButton from 'src/components/molecules/SelfObservationHomeScreenButton';
import QuickHelpHomeScreenButton from '../components/molecules/QuickHelpHomeScreenButton';
import BabyBornHomeScreenButton from '../components/molecules/BabyBornHomeScreenButton';
import ModulesHomeScreenButton from '../components/molecules/ModulesHomeScreenButton';
import OnboardingPopup from 'src/components/molecules/OnboardingPopup';
import StudyInfoHomeScreenButton from 'src/components/molecules/StudyInfoHomeScreenButton';
import DisabledScreen from '../components/molecules/DisabledScreen';
import TopBar from '../components/molecules/TopBar';
import TopBarSettingsButton from '../components/atoms/TopBarSettingsButton';
import { useAppSelector } from '../store/hooks';
import _ from 'underscore';
import { HomeMenuItemKey } from 'src/data/datatypes';

const HomeScreen = () => {
    const userDisabled = useAppSelector(state => state.globalState.user?.disabled);
    const config = useAppSelector(state => state.globalState.config);

    const homeScreenButtonsMap: Record<HomeMenuItemKey, JSX.Element> = {
        modules:
            <ModulesHomeScreenButton
                key="modules"
                customLabel={config?.homeMenuItems['modules']?.customMenuLabel}
                customIcon={config?.homeMenuItems['modules']?.customIcon}
            />,
        continue_session:
            <ContinueSessionHomeScreenButton
                key="continue_session"
                customLabel={config?.homeMenuItems['continue_session']?.customMenuLabel}
                customIcon={config?.homeMenuItems['continue_session']?.customIcon}
            />,
        self_observation:
            <SelfObservationHomeScreenButton
                key="self_observation"
                customLabel={config?.homeMenuItems['self_observation']?.customMenuLabel}
                customIcon={config?.homeMenuItems['self_observation']?.customIcon}
            />,
        favorites:
            <FavoritesHomeScreenButton
                key="favorites"
                customLabel={config?.homeMenuItems['favorites']?.customMenuLabel}
                customIcon={config?.homeMenuItems['favorites']?.customIcon}
            />,
        study_info:
            <StudyInfoHomeScreenButton
                key="study_info"
                customLabel={config?.homeMenuItems['study_info']?.customMenuLabel}
                customIcon={config?.homeMenuItems['study_info']?.customIcon}
            />,
        quick_help:
            <QuickHelpHomeScreenButton
                key="quick_help"
                customLabel={config?.homeMenuItems['quick_help']?.customMenuLabel}
                customIcon={config?.homeMenuItems['quick_help']?.customIcon}
            />,
        pick_coach:
            <PickCoachHomeScreenButton
                key="pick_coach"
                customLabel={config?.homeMenuItems['pick_coach']?.customMenuLabel}
                customIcon={config?.homeMenuItems['pick_coach']?.customIcon}
            />,
        baby_born:
            <BabyBornHomeScreenButton
                key="baby_born"
                customLabel={config?.homeMenuItems['baby_born']?.customMenuLabel}
                customIcon={config?.homeMenuItems['baby_born']?.customIcon}
            />,
    };

    let content = null;

    if (config) {
        const activeButtons = (Object.keys(config.homeMenuItems) as HomeMenuItemKey[])
            .filter(
                (key) => config.homeMenuItems?.[key]?.enabled === true
            )
            .map((key) => homeScreenButtonsMap[key])
            .filter(Boolean);

        content = (
            <div className="home-button-container-flex">
                {activeButtons}
            </div>
        );
    }

    if (userDisabled) {
        content = <DisabledScreen studyName={config?.name} />;
    }

    return (
        <>
            <OnboardingPopup />
            <div className="content content-home">
                <TopBar rightButtons={[<TopBarSettingsButton />]} title={config?.headerText} />
                <div className="content-container home-button-container">
                    {content}
                </div>
            </div>
        </>
    );
};

export default HomeScreen;